// extracted by mini-css-extract-plugin
export default {"icon":"SvgIcon__icon--7k3"};